export const PRODUCT_MEDIA_OPEN = 'PRODUCT_MEDIA_OPEN';
export const PRODUCT_MEDIA_SET_POSITION = 'PRODUCT_MEDIA_SET_POSITION';

export const productMediaOpen = position => ({
  type: PRODUCT_MEDIA_OPEN,
  show: true,
  position,
});

export const productMediaSetPosition = (position, { action }) => ({
  type: PRODUCT_MEDIA_SET_POSITION,
  position,
  action,
});

export default {
  productMediaOpen,
  productMediaSetPosition,
};
